import {useEffect} from "react";
import {useAuth} from "../../../../hooks/useAuth.ts";
import {
    Navigate,
    useNavigate,
    useSearchParams
} from "react-router-dom";
import {
    FlexiSignInButton,
    PlatformLoader
} from "@flexinet/ui-components";
import {
    Center,
    Stack,
    Title
} from "@mantine/core";

import {Cache} from 'aws-amplify/utils';
import {isAllowedRedirectUrl} from "../../../../utils/isAllowedRedirectUrl.ts";

export const AuthorizePage = () => {

    const navigate = useNavigate()

    const [params] = useSearchParams();

    const redirectUrl = params.get('redirect_uri')
    const responseType = params.get('response_type')
    const clientId = params.get('client_id')
    const identityProvider = params.get('identity_provider')
    const scope = params.get('scope')
    const state = params.get('state')

    // FNP-864: validate BEFORE caching. This component renders for signed-out
    // visitors too, so an unvalidated write here lets an attacker seed the
    // cache with their own origin and have the post-sign-in emitter deliver
    // tokens to it.
    const redirectUrlIsAllowed = isAllowedRedirectUrl(redirectUrl)

    useEffect(() => {
        if (!redirectUrlIsAllowed) {
            // Fail closed: never persist an unknown redirect target, and drop
            // any entry a previous request may have left behind.
            Cache.removeItem('authorization')
            return
        }

        Cache.setItem('authorization', {
            redirectUrl,
            responseType,
            clientId,
            identityProvider,
            scope,
            state
        })
    }, [redirectUrlIsAllowed, redirectUrl, responseType, clientId, identityProvider, scope, state])


    const {user} = useAuth()


    const {
        idToken,
        accessToken,
    } = useAuth();


    // const {
    //     customState,
    //     saveCustomState
    // } = useCustomState()

    // useEffect(() => {
    //     saveCustomState()
    // }, [])


    if (user) {

        if (typeof idToken === 'undefined' || typeof accessToken === 'undefined') {
            return <PlatformLoader/>
        }

        // FNP-864: re-validate immediately before emitting tokens. Fail closed
        // to the dashboard rather than throwing an unhandled error mid-render.
        if (!redirectUrlIsAllowed) {
            Cache.removeItem('authorization')
            return <Navigate to={'/dashboard'}/>
        }

        // FNP-864: never log this URL — it carries both raw tokens.
        const returnUrl = `${redirectUrl}#id_token=${idToken}&access_token=${accessToken}&token_type=Bearer&expires_in=3600&state=${state}`
        Cache.removeItem('authorization')
             .then(() => {
                 window.location.assign(returnUrl)
             })

    } else {

        return (<Center>
            <Stack>
                <Title my={'xl'}>Session has expired. Please, sign in again!</Title>
                <Center my={'xl'}>
                    <FlexiSignInButton onClick={() => navigate('/')}>Sign In</FlexiSignInButton>
                </Center>
            </Stack>
        </Center>)

    }


}
